import type { ActionFunctionArgs } from 'react-router-dom';
import Actions from '@/models/ui/actions.ts';

export const leadsAction = async (args: ActionFunctionArgs) => {
  const formData = await args.request.formData();
  const actionsKey = formData.get('action') as string;

  return Actions.getByKey(actionsKey).action(
    formData,
    args.params,
    new URL(args.request.url),
  );
};
